import { SystemField } from "./system-field";

export class ProductCostStatus extends SystemField{
     
     branch_id?:string;
     warehouse_id?:string;
     location_id?:string;
     product_id?:string;
     reference_id?:string;
     receipt_date?:string;
     receipt_from?:string;
     orig_qty?:number;
     onhand_qty?:number;
     unit_cost?:number;
     total_cost?:number;
     cost_method?:string;
}